/**
 * Landing page assembly component.
 *
 * Iterates the section registry and renders each section inside a
 * wrapper element with the appropriate id and background modifier class.
 *
 * @module landing/LandingPage
 */

import React from 'react';
import { LANDING_SECTIONS } from './section-registry';

/**
 * Assembles all landing page sections from the registry.
 */
export function LandingPage(): React.JSX.Element {
  return (
    <main>
      {LANDING_SECTIONS.map((descriptor) => {
        const SectionComponent = descriptor.component;
        return (
          <div
            key={descriptor.id}
            id={descriptor.id}
            className={`landing-section landing-section--${descriptor.background}`}
          >
            <SectionComponent />
          </div>
        );
      })}
    </main>
  );
}
